import React from "react";
import { Link } from "react-router-dom";

import { PROVIDER } from "../brand";
import { VERSION_LABEL } from "../version";

/**
 * The legal links, provider and build version, as one small line at the bottom of the
 * menus: the hamburger sheet on phones and the user menu on desktop (Navbar).
 *
 * This was a site-wide footer under every page. 34 screens size themselves to
 * `calc(100vh - 50px)`, so the footer always added its own height of scroll below a
 * full-height page — a page that should not scroll did, and it read like a website, not
 * an app (2026-10-22). Logged-out visitors still get both legal links in the sign-in
 * panel (LoginPanel).
 *
 * Earlier history: three columns of scaffolding with no hrefs were cut because dead links
 * in front of Apple's staff are worse than none. Add a link here only when it goes
 * somewhere (LegalLine.test.js checks every `to=` has a route).
 */
const LegalLine = ({ style }) => (
  <div
    style={{
      padding: "12px 14px",
      textAlign: "center",
      fontSize: "11px",
      lineHeight: 1.8,
      color: "#86868b",
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {/* Each item kept whole (nowrap), so a narrow menu breaks between items, never
        inside "Powered by MUSE · AKA". */}
    <Link to="/terms" style={{ color: "#86868b", whiteSpace: "nowrap" }}>이용약관</Link>
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    <Link to="/privacy" style={{ color: "#86868b", whiteSpace: "nowrap" }}>개인정보처리방침</Link>
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    <span style={{ whiteSpace: "nowrap" }}>{PROVIDER}</span>
    <span style={{ margin: "0 8px", opacity: 0.5 }}>·</span>
    {/* Dimmer than the rest: useful when a tester reports a bug, noise the other 99%
        of the time. Not a link — there is nothing at the other end for a trainee. */}
    <span style={{ opacity: 0.65, whiteSpace: "nowrap" }}>{VERSION_LABEL}</span>
  </div>
);

export default LegalLine;
